"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[760],{

/***/ 17530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Et": function() { return /* binding */ useMajorsListQuery; },
/* harmony export */   "Nc": function() { return /* binding */ useMajorsDestroyMutation; },
/* harmony export */   "gH": function() { return /* binding */ useMajorsCreateMutation; },
/* harmony export */   "ym": function() { return /* binding */ useMajorsPartialUpdateMutation; }
/* harmony export */ });
/* unused harmony exports addTagTypes, mystesApi, useLazyMajorsListQuery, useMajorsRetrieveQuery, useLazyMajorsRetrieveQuery, useMajorsUpdateMutation */
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36357);

const addTagTypes = [
    "majors"
];
const injectedRtkApi = _index__WEBPACK_IMPORTED_MODULE_0__/* .mystesApi.enhanceEndpoints */ .k.enhanceEndpoints({
    addTagTypes
}).injectEndpoints({
    endpoints: (build)=>({
            majorsList: build.query({
                query: ()=>({
                        url: "/api/v1/majors/"
                    }),
                providesTags: [
                    "majors"
                ]
            }),
            majorsCreate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/majors/",
                        method: "POST",
                        body: queryArg.major
                    }),
                invalidatesTags: [
                    "majors"
                ]
            }),
            majorsRetrieve: build.query({
                query: (queryArg)=>({
                        url: "/api/v1/majors/".concat(queryArg.id, "/")
                    }),
                providesTags: [
                    "majors"
                ]
            }),
            majorsUpdate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/majors/".concat(queryArg.id, "/"),
                        method: "PUT",
                        body: queryArg.major
                    }),
                invalidatesTags: [
                    "majors"
                ]
            }),
            majorsPartialUpdate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/majors/".concat(queryArg.id, "/"),
                        method: "PATCH",
                        body: queryArg.patchedMajor
                    }),
                invalidatesTags: [
                    "majors"
                ]
            }),
            majorsDestroy: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/majors/".concat(queryArg.id, "/"),
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "majors"
                ]
            })
        }),
    overrideExisting: false
});

const { useMajorsListQuery , useLazyMajorsListQuery , useMajorsCreateMutation , useMajorsRetrieveQuery , useLazyMajorsRetrieveQuery , useMajorsUpdateMutation , useMajorsPartialUpdateMutation , useMajorsDestroyMutation  } = injectedRtkApi;


/***/ }),

/***/ 47876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SV": function() { return /* binding */ useSessionsPartialUpdateMutation; },
/* harmony export */   "Yv": function() { return /* binding */ useSessionsDestroyMutation; },
/* harmony export */   "cA": function() { return /* binding */ useSessionsCreateMutation; },
/* harmony export */   "fU": function() { return /* binding */ useSessionsListQuery; },
/* harmony export */   "qq": function() { return /* binding */ useSessionsRetrieveQuery; }
/* harmony export */ });
/* unused harmony exports addTagTypes, mystesApi, useLazySessionsListQuery, useLazySessionsRetrieveQuery, useSessionsUpdateMutation */
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36357);

const addTagTypes = [
    "sessions"
];
const injectedRtkApi = _index__WEBPACK_IMPORTED_MODULE_0__/* .mystesApi.enhanceEndpoints */ .k.enhanceEndpoints({
    addTagTypes
}).injectEndpoints({
    endpoints: (build)=>({
            sessionsList: build.query({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/",
                        params: {
                            accept_applications: queryArg.acceptApplications
                        }
                    }),
                providesTags: [
                    "sessions"
                ]
            }),
            sessionsCreate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/",
                        method: "POST",
                        body: queryArg.session
                    }),
                invalidatesTags: [
                    "sessions"
                ]
            }),
            sessionsRetrieve: build.query({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/".concat(queryArg.id, "/")
                    }),
                providesTags: [
                    "sessions"
                ]
            }),
            sessionsUpdate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/".concat(queryArg.id, "/"),
                        method: "PUT",
                        body: queryArg.session
                    }),
                invalidatesTags: [
                    "sessions"
                ]
            }),
            sessionsPartialUpdate: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/".concat(queryArg.id, "/"),
                        method: "PATCH",
                        body: queryArg.patchedSession
                    }),
                invalidatesTags: [
                    "sessions"
                ]
            }),
            sessionsDestroy: build.mutation({
                query: (queryArg)=>({
                        url: "/api/v1/sessions/".concat(queryArg.id, "/"),
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "sessions"
                ]
            })
        }),
    overrideExisting: false
});

const { useSessionsListQuery , useLazySessionsListQuery , useSessionsCreateMutation , useSessionsRetrieveQuery , useLazySessionsRetrieveQuery , useSessionsUpdateMutation , useSessionsPartialUpdateMutation , useSessionsDestroyMutation  } = injectedRtkApi;


/***/ }),

/***/ 90206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export NextLinkComposed */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68346);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81719);







// Add support for the sx prop for consistency with the other branches.
const Anchor = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("a")({});
const NextLinkComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function NextLinkComposed(props, ref) {
    const { to , linkAs , replace , scroll , shallow , prefetch , legacyBehavior =true , locale , ...other } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        legacyBehavior: legacyBehavior,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
            ref: ref,
            ...other
        })
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
const NavLink = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Link(props, ref) {
    const { activeClassName ="active" , as , className: classNameProps , href , legacyBehavior , linkAs: linkAsProp , locale , noLinkStyle , prefetch , replace , role , scroll , shallow , ...other } = props;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const pathname = typeof href === "string" ? href : href.pathname;
    const className = (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classNameProps, {
        [activeClassName]: router.pathname === pathname && activeClassName
    });
    const isExternal = typeof href === "string" && (href.indexOf("http") === 0 || href.indexOf("mailto:") === 0);
    if (isExternal) {
        if (noLinkStyle) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                className: className,
                href: href,
                ref: ref,
                ...other
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: className,
            href: href,
            ref: ref,
            ...other
        });
    }
    const linkAs = linkAsProp || as;
    const nextjsProps = {
        to: href,
        linkAs,
        replace,
        scroll,
        shallow,
        prefetch,
        legacyBehavior,
        locale
    };
    if (noLinkStyle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextLinkComposed, {
            className: className,
            ref: ref,
            ...nextjsProps,
            ...other
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        component: NextLinkComposed,
        className: className,
        ref: ref,
        ...nextjsProps,
        ...other
    });
});
/* harmony default export */ __webpack_exports__["C"] = (NavLink);


/***/ }),

/***/ 71711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85101);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .SettingsContext */ .J6);


/***/ }),

/***/ 95760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 7 modules
var useTranslation = __webpack_require__(25125);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts
var use_settings = __webpack_require__(71711);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InsertDriveFile.js
var InsertDriveFile = __webpack_require__(44634);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(64631);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(28223);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./src/components/logo.tsx
var logo = __webpack_require__(2839);
// EXTERNAL MODULE: ./src/components/scrollbar.tsx + 27 modules
var scrollbar = __webpack_require__(70515);
;// CONCATENATED MODULE: ./src/layouts/tenant-switch/index.tsx



const TenantSwitch = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            alignItems: "center",
            direction: "row",
            spacing: 2,
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "inherit",
                        variant: "h6",
                        children: "Mystes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "neutral.400",
                        variant: "body2",
                        children: "\xc9cole de Guerre \xc9conomique"
                    })
                ]
            })
        })
    });
};
TenantSwitch.propTypes = {
    // @ts-ignore
    sx: (prop_types_default()).object
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(48317);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 7 modules
var ButtonBase = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(93481);
;// CONCATENATED MODULE: ./src/layouts/vertical-layout/side-nav-item.tsx







const SideNavItem = (props)=>{
    const { active , children , depth =0 , disabled , icon , label , open: openProp , path , title  } = props;
    const [open, setOpen] = (0,react.useState)(!!openProp);
    const handleToggle = (0,react.useCallback)(()=>{
        setOpen((prevOpen)=>!prevOpen);
    }, []);
    // Icons can be defined at top level only, deep levels have bullets instead of actual icons.
    let startIcon;
    if (depth === 0) {
        startIcon = icon;
    } else {
        startIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                alignItems: "center",
                display: "center",
                height: 20,
                justifyContent: "center",
                width: 20
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    backgroundColor: "var(--nav-item-icon-color)",
                    borderRadius: "50%",
                    height: 4,
                    opacity: 0,
                    width: 4,
                    ...active && {
                        backgroundColor: "var(--nav-item-icon-active-color)",
                        height: 6,
                        opacity: 1,
                        width: 6
                    }
                }
            })
        });
    }
    const offset = depth === 0 ? 0 : (depth - 1) * 16;
    // Branch
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                    disabled: disabled,
                    onClick: handleToggle,
                    sx: {
                        alignItems: "center",
                        borderRadius: 1,
                        display: "flex",
                        justifyContent: "flex-start",
                        pl: "".concat(16 + offset, "px"),
                        pr: "16px",
                        py: "6px",
                        textAlign: "left",
                        width: "100%",
                        ...active && {
                            ...depth === 0 && {
                                backgroundColor: "var(--nav-item-active-bg)"
                            }
                        },
                        "&:hover": {
                            backgroundColor: "var(--nav-item-hover-bg)"
                        }
                    },
                    children: [
                        startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: "span",
                            sx: {
                                alignItems: "center",
                                color: "var(--nav-item-icon-color)",
                                display: "inline-flex",
                                justifyContent: "center",
                                mr: 2,
                                ...active && {
                                    color: "var(--nav-item-icon-active-color)"
                                }
                            },
                            children: startIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: "span",
                            sx: {
                                color: "var(--nav-item-color)",
                                flexGrow: 1,
                                fontFamily: (theme)=>theme.typography.fontFamily,
                                fontSize: depth > 0 ? 13 : 14,
                                fontWeight: depth > 0 ? 500 : 600,
                                lineHeight: "24px",
                                whiteSpace: "nowrap",
                                ...active && {
                                    color: "var(--nav-item-active-color)"
                                },
                                ...disabled && {
                                    color: "var(--nav-item-disabled-color)"
                                }
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                            sx: {
                                color: "var(--nav-item-chevron-color)",
                                fontSize: 16,
                                ml: 2
                            },
                            children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: open,
                    sx: {
                        mt: 0.5
                    },
                    children: children
                })
            ]
        });
    }
    // Leaf
    let linkProps = undefined;
    if (path) {
        const isExternal = path.startsWith("http");
        linkProps = isExternal ? {
            component: "a",
            href: path,
            target: "_blank"
        } : {
            component: (link_default()),
            href: path
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            disabled: disabled,
            sx: {
                alignItems: "center",
                borderRadius: 1,
                display: "flex",
                justifyContent: "flex-start",
                pl: "".concat(16 + offset, "px"),
                pr: "16px",
                py: "6px",
                textAlign: "left",
                width: "100%",
                ...active && {
                    ...depth === 0 && {
                        backgroundColor: "var(--nav-item-active-bg)"
                    }
                },
                "&:hover": {
                    backgroundColor: "var(--nav-item-hover-bg)"
                }
            },
            ...linkProps,
            children: [
                startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        alignItems: "center",
                        color: "var(--nav-item-icon-color)",
                        display: "inline-flex",
                        justifyContent: "center",
                        mr: 2,
                        ...active && {
                            color: "var(--nav-item-icon-active-color)"
                        }
                    },
                    children: startIcon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        color: "var(--nav-item-color)",
                        flexGrow: 1,
                        fontFamily: (theme)=>theme.typography.fontFamily,
                        fontSize: depth > 0 ? 13 : 14,
                        fontWeight: depth > 0 ? 500 : 600,
                        lineHeight: "24px",
                        whiteSpace: "nowrap",
                        ...active && {
                            color: "var(--nav-item-active-color)"
                        },
                        ...disabled && {
                            color: "var(--nav-item-disabled-color)"
                        }
                    },
                    children: title
                }),
                label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        ml: 2
                    },
                    children: label
                })
            ]
        })
    });
};
SideNavItem.propTypes = {
    active: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    depth: (prop_types_default()).number,
    disabled: (prop_types_default()).bool,
    icon: (prop_types_default()).node,
    open: (prop_types_default()).bool,
    path: (prop_types_default()).string,
    title: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./src/layouts/vertical-layout/side-nav-section.tsx




const renderItems = (param)=>{
    let { depth =0 , items , pathname  } = param;
    return items.reduce((acc, item)=>reduceChildRoutes({
            acc,
            depth,
            item,
            pathname
        }), []);
};
const reduceChildRoutes = (param)=>{
    let { acc , depth , item , pathname  } = param;
    const checkPath = !!(item.path && pathname);
    const partialMatch = checkPath ? pathname.includes(item.path) : false;
    const exactMatch = checkPath ? pathname === item.path : false;
    if (item.items) {
        acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavItem, {
            active: partialMatch,
            depth: depth,
            disabled: item.disabled,
            icon: item.icon,
            label: item.label,
            open: partialMatch,
            path: item.path,
            title: item.title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                component: "ul",
                spacing: 0.5,
                sx: {
                    listStyle: "none",
                    m: 0,
                    p: 0
                },
                children: renderItems({
                    depth: depth + 1,
                    items: item.items,
                    pathname
                })
            })
        }, item.title));
    } else {
        acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavItem, {
            active: exactMatch,
            depth: depth,
            disabled: item.disabled,
            icon: item.icon,
            label: item.label,
            path: item.path,
            title: item.title
        }, item.title));
    }
    return acc;
};
const SideNavSection = (props)=>{
    const { items =[] , pathname , subheader ="" , ...other } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        component: "ul",
        spacing: 0.5,
        sx: {
            listStyle: "none",
            m: 0,
            p: 0
        },
        ...other,
        children: [
            subheader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "li",
                sx: {
                    color: "var(--nav-section-title-color)",
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: 1.66,
                    mb: 1,
                    ml: 1,
                    textTransform: "uppercase"
                },
                children: subheader
            }),
            renderItems({
                items,
                pathname
            })
        ]
    });
};
SideNavSection.propTypes = {
    items: (prop_types_default()).array,
    pathname: (prop_types_default()).string,
    subheader: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/layouts/mobile-nav/index.tsx












const MOBILE_NAV_WIDTH = 280;
const useCssVars = (color)=>{
    const theme = (0,useTheme/* default */.Z)();
    return (0,react.useMemo)(()=>{
        switch(color){
            // Blend-in and discreet have no difference on mobile because
            // there's a backdrop and differences are not visible
            case "blend-in":
            case "discreet":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.neutral[100],
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[600],
                        "--nav-item-icon-color": theme.palette.neutral[500],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
                        "--nav-item-chevron-color": theme.palette.neutral[700],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.text.primary,
                        "--nav-logo-border": theme.palette.neutral[100],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.text.secondary,
                        "--nav-item-hover-bg": theme.palette.action.hover,
                        "--nav-item-active-bg": theme.palette.action.selected,
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[400],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
                        "--nav-item-chevron-color": theme.palette.neutral[400],
                        "--nav-scrollbar-color": theme.palette.neutral[900]
                    };
                }
            case "evident":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                }
            default:
                return {};
        }
    }, [
        theme,
        color
    ]);
};
const MobileNav = (props)=>{
    const { color ="evident" , open , onClose , sections =[]  } = props;
    const pathname = (0,navigation.usePathname)();
    const cssVars = useCssVars(color);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        anchor: "left",
        onClose: onClose,
        open: open,
        PaperProps: {
            sx: {
                ...cssVars,
                backgroundColor: "var(--nav-bg)",
                color: "var(--nav-color)",
                width: MOBILE_NAV_WIDTH
            }
        },
        variant: "temporary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollbar/* Scrollbar */.L, {
            sx: {
                height: "100%",
                "& .simplebar-content": {
                    height: "100%"
                },
                "& .simplebar-scrollbar:before": {
                    background: "var(--nav-scrollbar-color)"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 2,
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: (link_default()),
                                href: "",
                                sx: {
                                    borderColor: "var(--nav-logo-border)",
                                    borderRadius: 1,
                                    borderStyle: "solid",
                                    borderWidth: 1,
                                    display: "flex",
                                    height: 40,
                                    p: "4px",
                                    width: 40
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenantSwitch, {
                                sx: {
                                    flexGrow: 1
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        component: "nav",
                        spacing: 2,
                        sx: {
                            flexGrow: 1,
                            px: 2
                        },
                        children: sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavSection, {
                                items: section.items,
                                pathname: pathname,
                                subheader: section.subheader
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "neutral.400",
                                variant: "subtitle1",
                                children: "Need help?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "neutral.400",
                                sx: {
                                    mb: 2
                                },
                                variant: "body2",
                                children: "Please check our docs."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                component: (link_default()),
                                fullWidth: true,
                                href: "/",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsertDriveFile/* default */.Z, {})
                                }),
                                variant: "contained",
                                children: "Documentation"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
MobileNav.propTypes = {
    color: prop_types_default().oneOf([
        "blend-in",
        "discreet",
        "evident"
    ]),
    onClose: (prop_types_default()).func,
    open: (prop_types_default()).bool,
    sections: (prop_types_default()).array
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MenuOutlined.js
var MenuOutlined = __webpack_require__(48833);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(92557);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(43963);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(95309);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(94690);
;// CONCATENATED MODULE: ./src/layouts/account-button/account-popover.tsx









const AccountPopover = (props)=>{
    const { anchorEl , onClose , open , ...other } = props;
    const { data  } = (0,next_auth_react.useSession)();
    const handleLogout = (0,react.useCallback)(async ()=>{
        try {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            await (0,next_auth_react.signOut)({
                callbackUrl: paths/* paths.auth.login */.H.auth.login
            });
        } catch (err) {
            console.error(err);
            dist/* default.error */.ZP.error("Something went wrong!");
        }
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* default */.ZP, {
        anchorEl: anchorEl,
        anchorOrigin: {
            horizontal: "center",
            vertical: "bottom"
        },
        disableScrollLock: true,
        onClose: onClose,
        open: !!open,
        PaperProps: {
            sx: {
                width: 200
            }
        },
        ...other,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    p: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        children: data === null || data === void 0 ? void 0 : data.user.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "body2",
                        children: data === null || data === void 0 ? void 0 : data.user.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    p: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                    component: (link_default()),
                    href: paths/* paths.account */.H.account,
                    sx: {
                        borderRadius: 1,
                        px: 1,
                        py: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                children: "Mon compte"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: "0 !important"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    p: 1,
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "inherit",
                    onClick: handleLogout,
                    size: "small",
                    children: "D\xe9connexion"
                })
            })
        ]
    });
};
AccountPopover.propTypes = {
    anchorEl: (prop_types_default()).any,
    onClose: (prop_types_default()).func,
    open: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./src/utils/get-initials.ts
var get_initials = __webpack_require__(36385);
;// CONCATENATED MODULE: ./src/layouts/account-button/index.tsx






const AccountButton = ()=>{
    const anchorRef = (0,react.useRef)(null);
    const [openPopover, setOpenPopover] = (0,react.useState)(false);
    const { data  } = (0,next_auth_react.useSession)();
    const handlePopoverOpen = (0,react.useCallback)(()=>{
        setOpenPopover(true);
    }, []);
    const handlePopoverClose = (0,react.useCallback)(()=>{
        setOpenPopover(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: ButtonBase/* default */.Z,
                onClick: handlePopoverOpen,
                ref: anchorRef,
                sx: {
                    alignItems: "center",
                    display: "flex",
                    borderWidth: 2,
                    borderStyle: "solid",
                    borderColor: "divider",
                    height: 40,
                    width: 40,
                    borderRadius: "50%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        height: 32,
                        width: 32
                    },
                    children: (0,get_initials/* getInitials */.Q)(data === null || data === void 0 ? void 0 : data.user.name)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPopover, {
                anchorEl: anchorRef.current,
                onClose: handlePopoverClose,
                open: openPopover
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/utils/noop.ts
const noop = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
};

;// CONCATENATED MODULE: ./src/components/dropdown/dropdown-context.tsx


const DropdownContext = /*#__PURE__*/ (0,react.createContext)({
    anchorEl: null,
    onMenuEnter: noop,
    onMenuLeave: noop,
    onTriggerEnter: noop,
    onTriggerLeave: noop,
    open: false
});

;// CONCATENATED MODULE: ./src/components/dropdown/dropdown.tsx




const Dropdown = (props)=>{
    const { children , delay =50  } = props;
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const cleanupRef = (0,react.useRef)(null);
    const handleTriggerEnter = (0,react.useCallback)((event)=>{
        clearTimeout(cleanupRef.current);
        setAnchorEl(event.currentTarget);
    }, []);
    const handleTriggerLeave = (0,react.useCallback)((_)=>{
        cleanupRef.current = setTimeout(()=>{
            setAnchorEl(null);
        }, delay);
    }, [
        delay
    ]);
    const handleMenuEnter = (0,react.useCallback)((_)=>{
        clearTimeout(cleanupRef.current);
    }, []);
    const handleMenuLeave = (0,react.useCallback)((_)=>{
        cleanupRef.current = setTimeout(()=>{
            setAnchorEl(null);
        }, delay);
    }, [
        delay
    ]);
    const open = !!anchorEl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContext.Provider, {
        value: {
            anchorEl,
            onMenuEnter: handleMenuEnter,
            onMenuLeave: handleMenuLeave,
            onTriggerEnter: handleTriggerEnter,
            onTriggerLeave: handleTriggerLeave,
            open
        },
        children: children
    });
};
Dropdown.propTypes = {
    children: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    delay: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./src/components/dropdown/dropdown-trigger.tsx



const DropdownTrigger = (props)=>{
    const { children  } = props;
    const { onTriggerEnter , onTriggerLeave  } = (0,react.useContext)(DropdownContext);
    return /*#__PURE__*/ (0,react.cloneElement)(children, {
        onMouseEnter: (event)=>{
            var _children_props, _children_props_onMouseEnter;
            (_children_props_onMouseEnter = (_children_props = children.props).onMouseEnter) === null || _children_props_onMouseEnter === void 0 ? void 0 : _children_props_onMouseEnter.call(_children_props, event);
            onTriggerEnter(event);
        },
        onMouseLeave: (event)=>{
            var _children_props, _children_props_onMouseLeave;
            (_children_props_onMouseLeave = (_children_props = children.props).onMouseLeave) === null || _children_props_onMouseLeave === void 0 ? void 0 : _children_props_onMouseLeave.call(_children_props, event);
            onTriggerLeave(event);
        }
    });
};
DropdownTrigger.propTypes = {
    children: (prop_types_default()).element.isRequired
};

;// CONCATENATED MODULE: ./src/components/dropdown/dropdown-menu.tsx





const DropdownMenu = (props)=>{
    const { anchorEl , children , PaperProps , ...other } = props;
    const ctx = (0,react.useContext)(DropdownContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
        anchorEl: anchorEl || ctx.anchorEl,
        anchorOrigin: {
            horizontal: "left",
            vertical: "bottom"
        },
        open: ctx.open,
        PaperProps: {
            ...PaperProps,
            onMouseEnter: ctx.onMenuEnter,
            onMouseLeave: ctx.onMenuLeave,
            sx: {
                ...PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.sx,
                pointerEvents: "auto"
            }
        },
        sx: {
            pointerEvents: "none"
        },
        transformOrigin: {
            horizontal: "left",
            vertical: "top"
        },
        ...other,
        children: children
    });
};
DropdownMenu.propTypes = {
    anchorEl: (prop_types_default()).any,
    // @ts-ignore
    anchorOrigin: (prop_types_default()).object,
    children: (prop_types_default()).any,
    disableScrollLock: (prop_types_default()).bool,
    PaperProps: (prop_types_default()).object,
    // @ts-ignore
    transformOrigin: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/components/dropdown/index.tsx




;// CONCATENATED MODULE: ./src/layouts/horizontal-layout/top-nav-item.tsx







const renderChildItems = (param)=>{
    let { items , depth =0  } = param;
    return items.map((item)=>{
        const { disabled , items , path , title  } = item;
        // Branch
        if (items) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTrigger, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                            disabled: disabled,
                            sx: {
                                borderRadius: 1,
                                px: 1.5,
                                py: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: item.title,
                                    primaryTypographyProps: {
                                        sx: {
                                            color: "text.secondary",
                                            fontSize: 14,
                                            fontWeight: 500
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                    fontSize: "small",
                                    sx: {
                                        color: "neutral.400"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu, {
                        anchorOrigin: {
                            horizontal: "right",
                            vertical: "top"
                        },
                        disableScrollLock: true,
                        PaperProps: {
                            elevation: 8,
                            sx: {
                                maxWidth: "100%",
                                ml: 1,
                                p: 1,
                                width: 200
                            }
                        },
                        transformOrigin: {
                            horizontal: "left",
                            vertical: "top"
                        },
                        children: renderChildItems({
                            items,
                            depth: depth + 1
                        })
                    })
                ]
            }, title);
        }
        let linkProps = undefined;
        if (path) {
            const isExternal = path.startsWith("http");
            linkProps = isExternal ? {
                component: "a",
                href: path,
                target: "_blank"
            } : {
                component: (link_default()),
                href: path
            };
        }
        // Leaf
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
            disabled: disabled,
            sx: {
                borderRadius: 1,
                px: 1.5,
                py: 0.5
            },
            ...linkProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: item.title,
                primaryTypographyProps: {
                    sx: {
                        color: "text.secondary",
                        fontSize: 14,
                        fontWeight: 500
                    }
                }
            })
        }, title);
    });
};
const TopNavItem = (props)=>{
    const { active , disabled , items , icon , label , path , title  } = props;
    // With dropdown
    if (items) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTrigger, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                            disabled: disabled,
                            sx: {
                                alignItems: "center",
                                borderRadius: 1,
                                display: "flex",
                                justifyContent: "flex-start",
                                px: "16px",
                                py: "6px",
                                textAlign: "left",
                                width: "100%",
                                ...active && {
                                    backgroundColor: "var(--nav-item-active-bg)"
                                },
                                "&:hover": {
                                    backgroundColor: "var(--nav-item-hover-bg)"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        alignItems: "center",
                                        color: "var(--nav-item-icon-color)",
                                        display: "inline-flex",
                                        justifyContent: "center",
                                        mr: 2,
                                        ...active && {
                                            color: "var(--nav-item-icon-active-color)"
                                        }
                                    },
                                    children: icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        color: "var(--nav-item-color)",
                                        flexGrow: 1,
                                        fontFamily: (theme)=>theme.typography.fontFamily,
                                        fontSize: 14,
                                        fontWeight: 600,
                                        lineHeight: "24px",
                                        whiteSpace: "nowrap",
                                        ...active && {
                                            color: "var(--nav-item-active-color)"
                                        },
                                        ...disabled && {
                                            color: "var(--nav-item-disabled-color)"
                                        }
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                    sx: {
                                        color: "var(--nav-item-chevron-color)",
                                        fontSize: 16,
                                        ml: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {})
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu, {
                    disableScrollLock: true,
                    PaperProps: {
                        elevation: 8,
                        sx: {
                            maxWidth: "100%",
                            p: 1,
                            width: 200
                        }
                    },
                    children: renderChildItems({
                        items,
                        depth: 0
                    })
                })
            ]
        });
    }
    // Without dropdown
    let linkProps = undefined;
    if (path) {
        const isExternal = path.startsWith("http");
        linkProps = isExternal ? {
            component: "a",
            href: path,
            target: "_blank"
        } : {
            component: (link_default()),
            href: path
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            disabled: disabled,
            sx: {
                alignItems: "center",
                borderRadius: 1,
                display: "flex",
                justifyContent: "flex-start",
                px: "16px",
                py: "6px",
                textAlign: "left",
                width: "100%",
                ...active && {
                    backgroundColor: "var(--nav-item-active-bg)"
                },
                "&:hover": {
                    backgroundColor: "var(--nav-item-hover-bg)"
                }
            },
            ...linkProps,
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        alignItems: "center",
                        color: "var(--nav-item-icon-color)",
                        display: "inline-flex",
                        justifyContent: "center",
                        mr: 2,
                        ...active && {
                            color: "var(--nav-item-icon-active-color)"
                        }
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        color: "var(--nav-item-color)",
                        flexGrow: 1,
                        fontFamily: (theme)=>theme.typography.fontFamily,
                        fontSize: 14,
                        fontWeight: 600,
                        lineHeight: "24px",
                        whiteSpace: "nowrap",
                        ...active && {
                            color: "var(--nav-item-active-color)"
                        },
                        ...disabled && {
                            color: "var(--nav-item-disabled-color)"
                        }
                    },
                    children: title
                }),
                label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        ml: 1
                    },
                    children: label
                })
            ]
        })
    });
};
TopNavItem.propTypes = {
    active: (prop_types_default()).bool,
    icon: (prop_types_default()).node,
    items: (prop_types_default()).array,
    label: (prop_types_default()).node,
    path: (prop_types_default()).string,
    title: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./src/layouts/horizontal-layout/top-nav-section.tsx




const TopNavSection = (props)=>{
    const { items =[] , pathname  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        component: "ul",
        direction: "row",
        spacing: 1,
        sx: {
            listStyle: "none",
            m: 0,
            p: 0
        },
        children: items.map((item)=>{
            const checkPath = !!(item.path && pathname);
            const partialMatch = checkPath ? pathname.includes(item.path) : false;
            const exactMatch = checkPath ? pathname === item.path : false;
            // Branch
            if (item.items) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavItem, {
                    active: partialMatch,
                    disabled: item.disabled,
                    icon: item.icon,
                    items: item.items,
                    label: item.label,
                    path: item.path,
                    title: item.title
                }, item.title);
            }
            // Leaf
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavItem, {
                active: exactMatch,
                disabled: item.disabled,
                icon: item.icon,
                label: item.label,
                path: item.path,
                title: item.title
            }, item.title);
        })
    });
};
TopNavSection.propTypes = {
    items: (prop_types_default()).array,
    pathname: (prop_types_default()).string,
    subheader: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/layouts/horizontal-layout/top-nav.tsx













const top_nav_useCssVars = (color)=>{
    const theme = (0,useTheme/* default */.Z)();
    return (0,react.useMemo)(()=>{
        switch(color){
            case "blend-in":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.neutral[100],
                        "--nav-divider-color": theme.palette.neutral[800],
                        "--nav-border-color": theme.palette.neutral[700],
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[600],
                        "--nav-item-icon-color": theme.palette.neutral[500],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
                        "--nav-item-chevron-color": theme.palette.neutral[700],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.text.primary,
                        "--nav-divider-color": theme.palette.divider,
                        "--nav-border-color": theme.palette.neutral[100],
                        "--nav-logo-border": theme.palette.neutral[100],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.text.secondary,
                        "--nav-item-hover-bg": theme.palette.action.hover,
                        "--nav-item-active-bg": theme.palette.action.selected,
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[400],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
                        "--nav-item-chevron-color": theme.palette.neutral[400],
                        "--nav-scrollbar-color": theme.palette.neutral[900]
                    };
                }
            case "discreet":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.neutral[900],
                        "--nav-color": theme.palette.neutral[100],
                        "--nav-divider-color": theme.palette.neutral[800],
                        "--nav-border-color": theme.palette.neutral[700],
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[600],
                        "--nav-item-icon-color": theme.palette.neutral[500],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
                        "--nav-item-chevron-color": theme.palette.neutral[700],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.neutral[50],
                        "--nav-color": theme.palette.text.primary,
                        "--nav-divider-color": theme.palette.neutral[200],
                        "--nav-border-color": theme.palette.divider,
                        "--nav-logo-border": theme.palette.neutral[200],
                        "--nav-section-title-color": theme.palette.neutral[500],
                        "--nav-item-color": theme.palette.neutral[500],
                        "--nav-item-hover-bg": theme.palette.action.hover,
                        "--nav-item-active-bg": theme.palette.action.selected,
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[400],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
                        "--nav-item-chevron-color": theme.palette.neutral[400],
                        "--nav-scrollbar-color": theme.palette.neutral[900]
                    };
                }
            case "evident":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-divider-color": theme.palette.neutral[700],
                        "--nav-border-color": "transparent",
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-divider-color": theme.palette.neutral[700],
                        "--nav-border-color": "transparent",
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                }
            default:
                return {};
        }
    }, [
        theme,
        color
    ]);
};
const TopNav = (props)=>{
    const { color ="evident" , onMobileNav , sections =[]  } = props;
    const pathname = (0,navigation.usePathname)();
    const mdUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("md"));
    const cssVars = top_nav_useCssVars(color);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "header",
        sx: {
            ...cssVars,
            backgroundColor: "var(--nav-bg)",
            borderBottomColor: "var(--nav-border-color)",
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            color: "var(--nav-color)",
            left: 0,
            position: "sticky",
            top: 0,
            zIndex: (theme)=>theme.zIndex.appBar
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                alignItems: "center",
                direction: "row",
                justifyContent: "space-between",
                spacing: 2,
                sx: {
                    px: 3,
                    py: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 2,
                        children: [
                            !mdUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: onMobileNav,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: (link_default()),
                                href: "/",
                                sx: {
                                    borderColor: "var(--nav-logo-border)",
                                    borderRadius: 1,
                                    borderStyle: "solid",
                                    borderWidth: 1,
                                    display: "inline-flex",
                                    height: 40,
                                    p: "4px",
                                    width: 40
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenantSwitch, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountButton, {})
                    })
                ]
            }),
            mdUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    borderTopWidth: 1,
                    borderTopStyle: "solid",
                    borderTopColor: "var(--nav-divider-color)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollbar/* Scrollbar */.L, {
                    sx: {
                        "& .simplebar-scrollbar:before": {
                            background: "var(--nav-scrollbar-color)"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        alignItems: "center",
                        component: "nav",
                        direction: "row",
                        spacing: 1,
                        sx: {
                            px: 2,
                            py: 1.5
                        },
                        children: sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavSection, {
                                items: section.items,
                                pathname: pathname,
                                subheader: section.subheader
                            }, index))
                    })
                })
            })
        ]
    });
};
TopNav.propTypes = {
    color: prop_types_default().oneOf([
        "blend-in",
        "discreet",
        "evident"
    ]),
    onMobileNav: (prop_types_default()).func,
    sections: (prop_types_default()).array
};

;// CONCATENATED MODULE: ./src/layouts/horizontal-layout/index.tsx








const useMobileNav = ()=>{
    const pathname = (0,navigation.usePathname)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const handlePathnameChange = (0,react.useCallback)(()=>{
        if (isOpen) {
            setIsOpen(false);
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        handlePathnameChange();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pathname
    ]);
    const handleOpen = (0,react.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return {
        isOpen,
        handleOpen,
        handleClose
    };
};
const HorizontalLayoutRoot = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%"
});
const HorizontalLayoutContainer = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    width: "100%"
});
const HorizontalLayout = (props)=>{
    const { children , navColor , sections  } = props;
    const lgUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("lg"));
    const mobileNav = useMobileNav();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNav, {
                color: navColor,
                onMobileNav: mobileNav.handleOpen,
                sections: sections
            }),
            !lgUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                color: navColor,
                onClose: mobileNav.handleClose,
                open: mobileNav.isOpen,
                sections: sections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLayoutRoot, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLayoutContainer, {
                    children: children
                })
            })
        ]
    });
};
HorizontalLayout.propTypes = {
    children: (prop_types_default()).node
};

;// CONCATENATED MODULE: ./src/utils/version.ts
const getVersion = ()=>{
    var _process_env_NEXT_PUBLIC_MYSTES_VERSION;
    return (_process_env_NEXT_PUBLIC_MYSTES_VERSION = "stable-1.3.5") !== null && _process_env_NEXT_PUBLIC_MYSTES_VERSION !== void 0 ? _process_env_NEXT_PUBLIC_MYSTES_VERSION : "stable";
};
/* harmony default export */ var version = (getVersion);

;// CONCATENATED MODULE: ./src/layouts/vertical-layout/side-nav.tsx












const SIDE_NAV_WIDTH = 280;
const side_nav_useCssVars = (color)=>{
    const theme = (0,useTheme/* default */.Z)();
    return (0,react.useMemo)(()=>{
        switch(color){
            case "blend-in":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.neutral[100],
                        "--nav-border-color": theme.palette.neutral[700],
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[600],
                        "--nav-item-icon-color": theme.palette.neutral[500],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
                        "--nav-item-chevron-color": theme.palette.neutral[700],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.background.default,
                        "--nav-color": theme.palette.text.primary,
                        "--nav-border-color": theme.palette.neutral[100],
                        "--nav-logo-border": theme.palette.neutral[100],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.text.secondary,
                        "--nav-item-hover-bg": theme.palette.action.hover,
                        "--nav-item-active-bg": theme.palette.action.selected,
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[400],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
                        "--nav-item-chevron-color": theme.palette.neutral[400],
                        "--nav-scrollbar-color": theme.palette.neutral[900]
                    };
                }
            case "discreet":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.neutral[900],
                        "--nav-color": theme.palette.neutral[100],
                        "--nav-border-color": theme.palette.neutral[700],
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[600],
                        "--nav-item-icon-color": theme.palette.neutral[500],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[700],
                        "--nav-item-chevron-color": theme.palette.neutral[700],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.neutral[50],
                        "--nav-color": theme.palette.text.primary,
                        "--nav-border-color": theme.palette.divider,
                        "--nav-logo-border": theme.palette.neutral[200],
                        "--nav-section-title-color": theme.palette.neutral[500],
                        "--nav-item-color": theme.palette.neutral[500],
                        "--nav-item-hover-bg": theme.palette.action.hover,
                        "--nav-item-active-bg": theme.palette.action.selected,
                        "--nav-item-active-color": theme.palette.text.primary,
                        "--nav-item-disabled-color": theme.palette.neutral[400],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[400],
                        "--nav-item-chevron-color": theme.palette.neutral[400],
                        "--nav-scrollbar-color": theme.palette.neutral[900]
                    };
                }
            case "evident":
                if (theme.palette.mode === "dark") {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-border-color": "transparent",
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                } else {
                    return {
                        "--nav-bg": theme.palette.neutral[800],
                        "--nav-color": theme.palette.common.white,
                        "--nav-border-color": "transparent",
                        "--nav-logo-border": theme.palette.neutral[700],
                        "--nav-section-title-color": theme.palette.neutral[400],
                        "--nav-item-color": theme.palette.neutral[400],
                        "--nav-item-hover-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-bg": "rgba(255, 255, 255, 0.04)",
                        "--nav-item-active-color": theme.palette.common.white,
                        "--nav-item-disabled-color": theme.palette.neutral[500],
                        "--nav-item-icon-color": theme.palette.neutral[400],
                        "--nav-item-icon-active-color": theme.palette.primary.main,
                        "--nav-item-icon-disabled-color": theme.palette.neutral[500],
                        "--nav-item-chevron-color": theme.palette.neutral[600],
                        "--nav-scrollbar-color": theme.palette.neutral[400]
                    };
                }
            default:
                return {};
        }
    }, [
        theme,
        color
    ]);
};
const SideNav = (props)=>{
    const { color ="evident" , sections =[]  } = props;
    const pathname = (0,navigation.usePathname)();
    const cssVars = side_nav_useCssVars(color);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        anchor: "left",
        open: true,
        PaperProps: {
            sx: {
                ...cssVars,
                backgroundColor: "var(--nav-bg)",
                borderRightColor: "var(--nav-border-color)",
                borderRightStyle: "solid",
                borderRightWidth: 1,
                color: "var(--nav-color)",
                width: SIDE_NAV_WIDTH
            }
        },
        variant: "permanent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollbar/* Scrollbar */.L, {
            sx: {
                height: "100%",
                "& .simplebar-content": {
                    height: "100%"
                },
                "& .simplebar-scrollbar:before": {
                    background: "var(--nav-scrollbar-color)"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 2,
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: (link_default()),
                                href: "/",
                                sx: {
                                    borderColor: "var(--nav-logo-border)",
                                    borderRadius: 1,
                                    borderStyle: "solid",
                                    borderWidth: 1,
                                    display: "flex",
                                    height: 40,
                                    p: "4px",
                                    width: 40
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenantSwitch, {
                                sx: {
                                    flexGrow: 1
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        component: "nav",
                        spacing: 2,
                        sx: {
                            flexGrow: 1,
                            px: 2
                        },
                        children: sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavSection, {
                                items: section.items,
                                pathname: pathname,
                                subheader: section.subheader
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: "Mystes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "neutral.400",
                                sx: {
                                    mb: 2
                                },
                                variant: "body2",
                                children: [
                                    "Version : ",
                                    version()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                component: (link_default()),
                                fullWidth: true,
                                href: "mailto:vincent.bernaud@aege.fr",
                                variant: "contained",
                                children: "Support"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
SideNav.propTypes = {
    color: prop_types_default().oneOf([
        "blend-in",
        "discreet",
        "evident"
    ]),
    sections: (prop_types_default()).array
};

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(72389);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(20293);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(81284);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(19594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 8 modules
var TextField = __webpack_require__(67659);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Lightbulb.js
var Lightbulb = __webpack_require__(542);
;// CONCATENATED MODULE: ./src/components/tip.tsx





const TipRoot = (0,styled/* default */.ZP)("div")((param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette.neutral[800] : theme.palette.neutral[100],
        borderRadius: theme.shape.borderRadius,
        display: "flex",
        padding: theme.spacing(1)
    };
});
const Tip = (props)=>{
    const { message  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TipRoot, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                color: "action",
                sx: {
                    mr: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbulb/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                color: "text.secondary",
                sx: {
                    alignItems: "center",
                    display: "flex",
                    "& span": {
                        fontWeight: 700,
                        mr: 0.5
                    }
                },
                variant: "caption",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Tip."
                    }),
                    " ",
                    message
                ]
            })
        ]
    });
};
Tip.propTypes = {
    message: (prop_types_default()).string.isRequired
};

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/useHits.js + 4 modules
var useHits = __webpack_require__(2684);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/useSearchBox.js + 1 modules
var useSearchBox = __webpack_require__(37386);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/components/Index.js + 1 modules
var Index = __webpack_require__(2417);
// EXTERNAL MODULE: ./src/components/NavLink.tsx
var NavLink = __webpack_require__(90206);
;// CONCATENATED MODULE: ./src/layouts/search-button/search-dialog.tsx











const queryHook = (query, search)=>{
    search(query);
};
const ApplicationsHits = (props)=>{
    const { onClose  } = props;
    const { hits , sendEvent  } = (0,useHits/* useHits */.O)({});
    return hits.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
            children: "Candidatures"
        }),
        children: hits.map((hit)=>{
            const name = "".concat(hit.candidate_firstname, " ").concat(hit.candidate_lastname.toUpperCase());
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                        alignItems: "flex-start",
                        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            edge: "end",
                            "aria-label": "show",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: undefined,
                                    children: (0,get_initials/* getInitials */.Q)(name)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                    href: {
                                        pathname: paths/* paths.applications.detail */.H.applications.detail,
                                        query: {
                                            id: hit.id
                                        }
                                    },
                                    onClick: onClose,
                                    color: "inherit",
                                    variant: "subtitle1",
                                    children: "".concat(hit.candidate_lastname.toUpperCase(), " ").concat(hit.candidate_firstname)
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                    href: {
                                        pathname: paths/* paths.sessions.detail */.H.sessions.detail,
                                        query: {
                                            id: hit.session_id
                                        }
                                    },
                                    onClick: onClose,
                                    color: "inherit",
                                    variant: "subtitle2",
                                    children: "".concat(hit.session)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        variant: "inset",
                        component: "li"
                    })
                ]
            });
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
const SessionHits = (props)=>{
    const { onClose  } = props;
    const { hits , sendEvent  } = (0,useHits/* useHits */.O)({});
    return hits.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
            children: "Promotions"
        }),
        children: hits.map((hit)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                        alignItems: "flex-start",
                        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            edge: "end",
                            "aria-label": "show",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: undefined,
                                    children: (0,get_initials/* getInitials */.Q)(hit.name)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                    href: {
                                        pathname: paths/* paths.sessions.detail */.H.sessions.detail,
                                        query: {
                                            id: hit.objectID
                                        }
                                    },
                                    onClick: onClose,
                                    color: "inherit",
                                    variant: "subtitle1",
                                    children: hit.name
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.secondary",
                                    variant: "subtitle2",
                                    children: "Ann\xe9e ".concat(hit.year)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        variant: "inset",
                        component: "li"
                    })
                ]
            });
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
const SearchDialog = (props)=>{
    const { onClose , open =false , ...other } = props;
    const [value, setValue] = (0,react.useState)("");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [displayArticles, setDisplayArticles] = (0,react.useState)(false);
    const { query , refine , clear  } = (0,useSearchBox/* useSearchBox */.l)({
        queryHook
    });
    const handleSubmit = (0,react.useCallback)(async (event)=>{
        event.preventDefault();
        setIsLoading(true);
        if (value.length === 0) {
            clear();
        } else {
            refine(value);
        }
        setIsLoading(false);
    }, [
        clear,
        refine,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        fullWidth: true,
        maxWidth: "sm",
        onClose: onClose,
        open: open,
        ...other,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                alignItems: "center",
                direction: "row",
                justifyContent: "space-between",
                spacing: 3,
                sx: {
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        children: "Recherche"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        color: "inherit",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                sx: {
                    pt: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tip, {
                        message: "Entrez vos mots-cl\xe9s et appuyez sur Entrer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "form",
                        onSubmit: handleSubmit,
                        sx: {
                            mt: 3,
                            mb: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            fullWidth: true,
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                    position: "start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                                })
                            },
                            label: "Recherche",
                            onChange: (event)=>setValue(event.target.value),
                            placeholder: "...",
                            value: value
                        })
                    }),
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* Index */.g, {
                        indexName: "mystes_prod_Session",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionHits, {
                            onClose: onClose
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* Index */.g, {
                        indexName: "mystes_prod_Application",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationsHits, {
                            onClose: onClose
                        })
                    })
                ]
            })
        ]
    });
};
SearchDialog.propTypes = {
    onClose: (prop_types_default()).func,
    open: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/components/InstantSearch.js + 30 modules
var InstantSearch = __webpack_require__(93166);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(24955);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
;// CONCATENATED MODULE: ./src/layouts/search-button/index.tsx







const algoliaClient = algoliasearch_umd_default()("5DVGLD2VMI", "3801fa34f4e738f95c5a32d466451893");
const searchClient = {
    ...algoliaClient,
    search (requests) {
        if (requests.every((param)=>{
            let { params  } = param;
            return !(params === null || params === void 0 ? void 0 : params.query);
        })) {
            return Promise.resolve({
                results: requests.map(()=>({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                        hitsPerPage: 0,
                        exhaustiveNbHits: false,
                        query: "",
                        params: ""
                    }))
            });
        }
        return algoliaClient.search(requests);
    }
};
const Hit = (props)=>{
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
const SearchButton = ()=>{
    const [openDialog, setOpenDialog] = (0,react.useState)(false);
    const handleOpen = (0,react.useCallback)(()=>{
        setOpenDialog(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setOpenDialog(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "Rechercher",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: handleOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearch/* InstantSearch */.p, {
                searchClient: searchClient,
                indexName: "mystes_prod_Application",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDialog, {
                    onClose: handleClose,
                    open: openDialog
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/vertical-layout/top-nav.tsx







const TOP_NAV_HEIGHT = 64;
const top_nav_SIDE_NAV_WIDTH = 280;
const top_nav_TopNav = (props)=>{
    const { onMobileNavOpen , ...other } = props;
    const lgUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("lg"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "header",
        sx: {
            backdropFilter: "blur(6px)",
            backgroundColor: (theme)=>(0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0.8),
            position: "sticky",
            left: {
                lg: "".concat(top_nav_SIDE_NAV_WIDTH, "px")
            },
            top: 0,
            width: {
                lg: "calc(100% - ".concat(top_nav_SIDE_NAV_WIDTH, "px)")
            },
            zIndex: (theme)=>theme.zIndex.appBar
        },
        ...other,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            alignItems: "center",
            direction: "row",
            justifyContent: "space-between",
            spacing: 2,
            sx: {
                minHeight: TOP_NAV_HEIGHT,
                px: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    alignItems: "center",
                    direction: "row",
                    spacing: 2,
                    children: [
                        !lgUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: onMobileNavOpen,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    alignItems: "center",
                    direction: "row",
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountButton, {})
                })
            ]
        })
    });
};
top_nav_TopNav.propTypes = {
    onMobileNavOpen: (prop_types_default()).func
};

;// CONCATENATED MODULE: ./src/layouts/vertical-layout/index.tsx









const vertical_layout_SIDE_NAV_WIDTH = 280;
const vertical_layout_useMobileNav = ()=>{
    const pathname = (0,navigation.usePathname)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const handlePathnameChange = (0,react.useCallback)(()=>{
        if (isOpen) {
            setIsOpen(false);
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        handlePathnameChange();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pathname
    ]);
    const handleOpen = (0,react.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0,react.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return {
        isOpen,
        handleOpen,
        handleClose
    };
};
const VerticalLayoutRoot = (0,styled/* default */.ZP)("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flex: "1 1 auto",
        maxWidth: "100%",
        [theme.breakpoints.up("lg")]: {
            paddingLeft: vertical_layout_SIDE_NAV_WIDTH
        }
    };
});
const VerticalLayoutContainer = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    width: "100%"
});
const VerticalLayout = (props)=>{
    const { children , sections , navColor  } = props;
    const lgUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("lg"));
    const mobileNav = vertical_layout_useMobileNav();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav_TopNav, {
                onMobileNavOpen: mobileNav.handleOpen
            }),
            lgUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideNav, {
                color: navColor,
                sections: sections
            }),
            !lgUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                color: navColor,
                onClose: mobileNav.handleClose,
                open: mobileNav.isOpen,
                sections: sections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLayoutRoot, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLayoutContainer, {
                    children: children
                })
            })
        ]
    });
};
VerticalLayout.propTypes = {
    children: (prop_types_default()).node
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircle.js
var AccountCircle = __webpack_require__(28201);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Explore.js
var Explore = __webpack_require__(5306);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Groups.js
var Groups = __webpack_require__(27547);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/School.js
var School = __webpack_require__(88698);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Home.js
var Home = __webpack_require__(76638);
;// CONCATENATED MODULE: ./src/layouts/config.tsx








const getSections = (t, sessions, majors)=>{
    const sessionsItems = sessions.map((session)=>{
        const path = (0,paths/* getUrl */.G)(paths/* paths.sessions.detail */.H.sessions.detail, {
            id: session.id
        });
        return {
            major: session.major,
            item: {
                title: session.name,
                path: path
            }
        };
    });
    const majorsItems = majors.map((major)=>{
        const path = (0,paths/* getUrl */.G)(paths/* paths.majors.detail */.H.majors.detail, {
            id: major.id
        });
        return {
            title: major.name,
            path: path,
            items: sessionsItems.filter((item)=>item.major === major.id).map((item)=>item.item)
        };
    });
    return [
        {
            subheader: t("General"),
            items: [
                {
                    title: t("Tableau de bord"),
                    path: paths/* paths.index */.H.index,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home/* default */.Z, {})
                },
                {
                    title: t("Acc\xe8s rapide"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Explore/* default */.Z, {}),
                    items: majorsItems
                }
            ]
        },
        {
            subheader: t("Donn\xe9es"),
            items: [
                {
                    title: t("Candidatures"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {}),
                    items: [
                        {
                            title: t("Liste"),
                            path: paths/* paths.applications.index */.H.applications.index
                        },
                        {
                            title: t("Ajouter"),
                            path: paths/* paths.applications.create */.H.applications.create
                        }
                    ]
                },
                {
                    title: t("Promotions"),
                    path: paths/* paths.sessions.index */.H.sessions.index,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Groups/* default */.Z, {}),
                    items: [
                        {
                            title: t("Liste"),
                            path: paths/* paths.sessions.index */.H.sessions.index
                        },
                        {
                            title: t("Ajouter"),
                            path: paths/* paths.sessions.create */.H.sessions.create
                        }
                    ]
                },
                {
                    title: t("Formations"),
                    path: paths/* paths.majors.index */.H.majors.index,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(School/* default */.Z, {}),
                    items: [
                        {
                            title: t("Liste"),
                            path: paths/* paths.majors.index */.H.majors.index
                        },
                        {
                            title: t("Ajouter"),
                            path: paths/* paths.majors.create */.H.majors.create
                        }
                    ]
                }
            ]
        },
        {
            subheader: t("Param\xe8tres"),
            items: [
                {
                    title: t("Mon compte"),
                    path: paths/* paths.account */.H.account,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
                }
            ]
        }
    ];
};

// EXTERNAL MODULE: ./src/api/sessions.ts
var api_sessions = __webpack_require__(47876);
// EXTERNAL MODULE: ./src/api/majors.ts
var api_majors = __webpack_require__(17530);
;// CONCATENATED MODULE: ./src/layouts/index.tsx










const useTranslatedSections = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const { data: sessionsRaw = []  } = (0,api_sessions/* useSessionsListQuery */.fU)({});
    const { data: majorsRaw = []  } = (0,api_majors/* useMajorsListQuery */.Et)();
    const sessions = [
        ...sessionsRaw
    ].sort((a, b)=>a.name.localeCompare(b.name));
    const majors = [
        ...majorsRaw
    ].sort((a, b)=>a.name.localeCompare(b.name));
    return (0,react.useMemo)(()=>getSections(t, sessions, majors), [
        t,
        majors,
        sessions
    ]);
};
const Layout = (props)=>{
    const settings = (0,use_settings/* useSettings */.r)();
    const sections = useTranslatedSections();
    if (settings.layout === "horizontal") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLayout, {
            sections: sections,
            navColor: settings.navColor,
            ...props
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLayout, {
        sections: sections,
        navColor: settings.navColor,
        ...props
    });
};
Layout.propTypes = {
    children: (prop_types_default()).node
};


/***/ }),

/***/ 94690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getUrl; },
/* harmony export */   "H": function() { return /* binding */ paths; }
/* harmony export */ });
const paths = {
    index: "/",
    account: "/account",
    auth: {
        login: "/auth/login",
        logout: "/auth/logout"
    },
    error: {
        error401: "/401",
        error403: "/403",
        error404: "/404",
        error500: "/500"
    },
    majors: {
        index: "/majors",
        create: "/majors/create",
        detail: "/majors/[id]",
        edit: "/majors/[id]/edit"
    },
    operations: {
        index: "/operations"
    },
    sessions: {
        index: "/sessions",
        create: "/sessions/create",
        detail: "/sessions/[id]",
        edit: "/sessions/[id]/edit"
    },
    applications: {
        index: "/applications",
        create: "/applications/create",
        detail: "/applications/[id]",
        edit: "/applications/[id]/edit"
    }
};
const getUrl = (pathname, data)=>{
    let url = pathname;
    if (!data) {
        return url;
    }
    let key;
    for(key in data){
        const urlObj = data[key].toString();
        url = url.replace("[".concat(key, "]"), urlObj);
    }
    return url;
};


/***/ }),

/***/ 36385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
const getInitials = function() {
    let name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return name.replace(/\s+/, " ").split(" ").slice(0, 2).map((v)=>v && v[0].toUpperCase()).join("");
};


/***/ })

}]);